import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { resetPassword } from '../api/userApi';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage('');
    setError('');

    // 🔐 validations frontend
    if (!token) {
      setError("Token invalide ou manquant");
      return;
    }

    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }

    if (password.length < 6) {
      setError("Le mot de passe doit contenir au moins 6 caractères");
      return;
    }

    setLoading(true);

    try {
      const response = await resetPassword({
        token,
        newPassword: password
      });

      setMessage(
        response.data?.message ||
        "Mot de passe mis à jour avec succès"
      );

      // ⏳ redirection après succès
      setTimeout(() => {
        navigate('/login');
      }, 2000);

    } catch (error) {
      const backend = error.response?.data;

      setError(
        backend?.message ||
        backend?.error ||
        "Erreur lors de la réinitialisation du mot de passe"
      );

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "450px" }}>

      <h2 className="mb-4 text-center">
        Nouveau mot de passe
      </h2>

      {/* TOKEN ERROR */}
      {!token && (
        <div className="alert alert-danger">
          Lien invalide ou token manquant
        </div>
      )}

      {/* SUCCESS */}
      {message && (
        <div className="alert alert-success">
          {message}
        </div>
      )}

      {/* ERROR */}
      {error && (
        <div className="alert alert-danger">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>

        {/* PASSWORD */}
        <div className="form-group mb-3">
          <label>Nouveau mot de passe</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="********"
            required
          />
        </div>

        {/* CONFIRM PASSWORD */}
        <div className="form-group mb-3">
          <label>Confirmer mot de passe</label>
          <input
            type="password"
            className="form-control"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="********"
            required
          />
        </div>

        <button
          className="btn btn-primary w-100"
          type="submit"
          disabled={loading || !token}
        >
          {loading ? "Mise à jour..." : "Réinitialiser le mot de passe"}
        </button>

      </form>
    </div>
  );
};

export default ResetPassword;